import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'

export default (reducers: any) => {
  const persistedReducer = persistReducer(
    {
      key: 'servemeiweb',
      storage,
      whitelist: ['auth', 'user', 'boleto', 'fiscal', 'sidebarclient'],
    },
    reducers,
  )

  return persistedReducer
}
